
// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Sidebar from "./sidebar";
// import NavPointsIcon from "../assets/Icons/points-icon.svg";

// import { XMarkIcon, Bars3Icon } from "@heroicons/react/24/outline";
// import logoes from "../assets/Logo.png";
// import languageLogo from "../assets/Icons/language-icon-matrimony.png";
// import NavBar from "./navbar";
// import Footer from "./footer";
// import { useNavigate } from "react-router-dom";

// const Points = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

//   const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);

//   const [isRechargePointsFormOpen, setIsRechargePointsFormOpen] =
//     useState(false);

//   const [userProfile, setUserProfile] = useState(null);
//   const [spendHistory, setSpendHistory] = useState([]);
//   const navigate = useNavigate();

//   const toggleLanguageDropdown = () => {
//     setShowLanguageDropdown((prev) => !prev);
//   };

//   const handleLanguageChange = (lang) => {
//     setLanguage(lang);
//     setShowLanguageDropdown(false);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (showLanguageDropdown && !event.target.closest(".language-dropdown")) {
//         setShowLanguageDropdown(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [showLanguageDropdown]);

//   const modalVariants = {
//     hidden: { opacity: 0, scale: 0.8 },
//     visible: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
//   };

//   const [points, setPoints] = useState();
//   const [formData, setFormData] = useState({
//     rechargeAmount: "",
//   });
//   const [success, setSuccess] = useState(false);

//   const handleRechargePoints = async (e) => {
//   e.preventDefault();
//   const token = localStorage.getItem("authToken");

//   try {
//     const response = await fetch(
//       `https://backend.newbrindha.com/wallet/recharge?amount=${formData.rechargeAmount}`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       },
//     );

//     if (response.ok) {
//       const data = await response.json();

//       if (data.token) {
//         localStorage.setItem("authToken", data.token);
//       }
//       setSuccess(true);
//       setIsRechargePointsFormOpen(false);

//       const balanceResponse = await fetch(
//         "https://backend.newbrindha.com/wallet/balance",
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );
//       if (balanceResponse.ok) {
//         const balanceData = await balanceResponse.json();
//         window.dispatchEvent(
//           new CustomEvent("updatePoints", {
//             detail: balanceData.points_balance,
//           }),
//         );
//       }

//       fetchPoints();
      
//       setTimeout(() => {
//         navigate("/home");
//       }, 2000);
//     } else {
//       throw new Error("Failed to Recharge");
//     }
//   } catch (error) {
//     console.error(error.message);
//   }
// };

//   const [language, setLanguage] = useState(() => {
//     const savedLanguage = localStorage.getItem("language");
//     return savedLanguage || "english"; 
//   });

  
//   const handleAmountChange = (e) => {
//     setFormData({ ...formData, rechargeAmount: e.target.value });
//   };

  
//   const fetchUserProfile = async () => {
//     try {
//       const token = localStorage.getItem("authToken");

//       const response = await fetch(
//         `https://backend.newbrindha.com/matrimony/my_profiles`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       if (response.status === 401) {
//         localStorage.removeItem("authToken");
//         return;
//       }

//       if (!response.ok) {
//         throw new Error("Failed to fetch profiles");
//       }

//       // Fetching Data
//       const data = await response.json();
//       setUserProfile(data.profile);
//     } catch (error) {
//       console.log(error.message);
//     }
//   };

//   // Handle Fetch Points
//   const fetchPoints = async () => {
//     try {
//       const token = localStorage.getItem("authToken");

//       const response = await fetch(
//         `https://backend.newbrindha.com/wallet/balance`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       if (response.status === 401) {
//         localStorage.removeItem("authToken");
//         return;
//       }

//       if (!response.ok) {
//         throw new Error("Failed to fetch Points");
//       }

//       // Fetching Points
//       const data = await response.json();
//       setPoints(data.points_balance);
//     } catch (error) {
//       console.log(error.message);
//     }
//   };

//   // Handle Fetch Spend History
//   const fetchSpendHistory = async () => {
//     try {
//       const token = localStorage.getItem("authToken");

//       const response = await fetch(
//         `https://backend.newbrindha.com/wallet/spend/latest`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       if (response.status === 401) {
//         localStorage.removeItem("authToken");
//         return;
//       }

//       if (!response.ok) {
//         throw new Error("Failed to Fetching Spend History");
//       }

//       // Fetching Spend History
//       const data = await response.json();
//       setSpendHistory(data.results);
//       console.log(data);
//       console.log(spendHistory);
//     } catch (error) {
//       console.log(error.message);
//     }
//   };

//   useEffect(() => {
//     fetchUserProfile();
//     fetchPoints();
//     fetchSpendHistory();
//   }, []);

//   // Hide success Message
//   setTimeout(() => {
//     setSuccess(false);
//   }, 8000);

//   return (
//     <div className="flex min-h-screen flex-col bg-gradient-to-br from-orange-100 via-violet-200 to-indigo-300 bg-[length:400%_400%] animate-gradient font-poppins overflow-hidden relative p-0">
//       {/* Sidebar */}
//       {/* <Sidebar
//         isSidebarOpen={isSidebarOpen}
//         setIsSidebarOpen={setIsSidebarOpen}
//         language={language}
//         logo={logoes}
//         translations={{
//           english: {
//             //dashboard: "Dashboard",
//             home: "Home",
//             myprofile: "My Profile",
//             points: "Points",
//             favourites: "Favourites",
//             matchingProfiles: "Matching Profiles",
//             logout: "Logout",
//           },
//           tamil: {
//             //dashboard: "டாஷ்போர்டு",
//             home: "முகப்பு",
//             myprofile: "சுயவிவரம்",
//             points: "புள்ளிகள்",
//             favourites: "பிடித்தவை",
//             matchingProfiles: "பொருத்தம்",
//             settings: "அமைப்புகள்",
//             logout: "வெளியேறு",
//           },
//         }}
//       /> */}

//       <div className="min-h-[100dvh] flex-grow w-full">
//         {/* Main Content */}
//         <motion.main
//           className={`flex-1 transition-all duration-300 ${
//             isSidebarOpen ? "lg:ml-64" : "ml-0"
//           }`}
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.5 }}
//         >
//           <header className="sticky top-0 z-50">
//             <NavBar />
//           </header>

//           {/* Points Section */}
//           <section className="mb-10 pt-20 overflow-y-auto px-4 sm:px-6">
//             <article className="flex items-center justify-between py-2">
//               {userProfile && (
//                 <div className="flex items-center gap-4 rounded-lg">
//                   <img
//                     src={userProfile.photo_path}
//                     alt={userProfile.full_name}
//                     className="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] object-cover bg-gray-300 rounded-full"
//                   />
//                   <div className="flex flex-col">
//                     <p className="text-[18px] font-semibold mb-1.5">
//                       {userProfile.full_name}
//                     </p>
//                     <button className="flex items-center justify-start gap-1.5 text-[#222] font-semibold text-[15px]">
//                       <img
//                         src={NavPointsIcon}
//                         alt="language-logo"
//                         className=" w-6 h-6 sm:h-7 sm:w-7 md:h-7 md:w-7"
//                       />
//                       {points}
//                     </button>
//                   </div>
//                 </div>
//               )}

//               {/* Points Button */}
//               <div>
//                 <button
//                   onClick={() => setIsRechargePointsFormOpen(true)}
//                   className="w-full text-center px-3 py-2 sm:px-3.5 sm:py-2 text-white font-medium bg-[#fc804f] hover:bg-[#fb6b32] active:bg-[#ff8350] rounded-lg"
//                 >
//                   Recharge Points
//                 </button>
//               </div>
//             </article>
//           </section>

//           {/* Points History */}
//           <section className="px-4 sm:px-6">
//             <div className="mx-auto max-w-[920px] overflow-x-auto rounded-lg overflow-y-auto">
//               <p className="text-[18px] text-[#222] font-medium mb-3">
//                 Points History
//               </p>
//               <table className="w-full bg-white">
//                 <thead className="bg-[#ff8350]">
//                   <tr>
//                     <th className=" pr-4 py-2 sm:pl-4 text-[15px] font-semibold text-white uppercase tracking-wider">
//                       Matrimony ID
//                     </th>
//                     <th className=" pr-4 py-2 sm:pl-4 text-[15px] font-semibold text-white uppercase tracking-wider">
//                       Profile Name
//                     </th>
//                     <th className=" pr-4 py-2 sm:pl-4 text-[15px] font-semibold text-white uppercase tracking-wider">
//                       Points Spent
//                     </th>
//                     {/* <th className="px-4 py-3 text-left text-[15px] font-semibold text-white uppercase tracking-wider">Visit Time</th> */}
//                   </tr>
//                 </thead>
//                 <tbody className="">
//                   {spendHistory && spendHistory.length > 0 ? (
//                     spendHistory.map((user) => (
//                       <tr
//                         key={user.target_profile_id}
//                         className="hover:bg-gray-50"
//                       >
//                         <td className="pr-4 sm:pl-4 py-2 text-[15px] text-gray-700">
//                           {user.target_profile_id}
//                         </td>
//                         <td className="pr-4 sm:pl-4 py-2 text-[15px] text-gray-700">
//                           {user.target_profile_name}
//                         </td>
//                         <td className="pr-4 sm:pl-4 py-2 text-[15px] text-gray-700">
//                           {user.points_spent}
//                         </td>
//                         {/* <td className="px-4 py-2 whitespace-nowrap text-[15px] text-gray-700">{user.timestamp.slice(0, 10)}</td> */}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={4}
//                         className="px-4 py-4 text-center text-gray-400 text-sm"
//                       >
//                         No spent history found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </section>

//           <AnimatePresence>
//             {success && (
//               <motion.div
//                 className="flex items-center justify-center p-4 z-50"
//                 initial="hidden"
//                 animate="visible"
//                 exit="hidden"
//                 variants={modalVariants}
//               >
//                 <motion.div
//                   className="bg-green-300 rounded-xl w-fit px-3.5 py-3"
//                   variants={modalVariants}
//                 >
//                   <h2 className="text-[16px] font-semibold text-[#3c3c3c]">
//                     🎉 Recharged Successfull... Check your Points ✨
//                   </h2>
//                 </motion.div>
//               </motion.div>
//             )}
//           </AnimatePresence>

//           {/* Recharge Points Modal */}
//           <AnimatePresence>
//             {isRechargePointsFormOpen && (
//               <motion.div
//                 className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
//                 initial="hidden"
//                 animate="visible"
//                 exit="hidden"
//                 variants={modalVariants}
//               >
//                 <motion.div
//                   className="bg-white rounded-xl max-w-md w-full p-6"
//                   variants={modalVariants}
//                 >
//                   <div className="flex justify-between items-start mb-4">
//                     <h2 className="text-xl font-semibold text-[#3c3c3c]">
//                       Recharge Points
//                     </h2>
//                     <button
//                       onClick={() => setIsRechargePointsFormOpen(false)}
//                       className="p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200"
//                     >
//                       <XMarkIcon className="h-5 w-5" />
//                     </button>
//                   </div>

//                   <form onSubmit={handleRechargePoints} className="space-y-4">
//                     <div>
//                       <label className="block text-sm font-medium text-[#676666] mb-2">
//                         Select Amount
//                       </label>
//                       <select
//                         name="rechargeAmount"
//                         id="pointsRecharge"
//                         className="appearance-none w-full px-2 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all duration-200 focus:outline-none focus:border-none text-[15px]"
//                         value={formData.rechargeAmount}
//                         onChange={handleAmountChange}
//                         required
//                       >
//                         <option value="select amount">select amount</option>
//                         <option value="200">200</option>
//                         <option value="500">500</option>
//                         <option value="1000">1000</option>
//                       </select>
//                     </div>

//                     <button
//                       type="submit"
//                       className="w-full px-4 py-2 bg-[#ff8350] text-white rounded-lg hover:bg-[#fb6b32] active:bg-[#ff8350] transition-all duration-200 shadow-lg"
//                     >
//                       Proceed to Payment
//                     </button>
//                   </form>
//                 </motion.div>
//               </motion.div>
//             )}
//           </AnimatePresence>
//         </motion.main>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default Points;


import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "./sidebar";
import NavPointsIcon from "../assets/Icons/points-icon.svg";
import { XMarkIcon, Bars3Icon } from "@heroicons/react/24/outline";
import logoes from "../assets/Logo.png";
import languageLogo from "../assets/Icons/language-icon-matrimony.png";
import NavBar from "./navbar";
import Footer from "./footer";
import { useNavigate } from "react-router-dom";

const Points = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [isRechargePointsFormOpen, setIsRechargePointsFormOpen] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [spendHistory, setSpendHistory] = useState([]);
  const navigate = useNavigate();

  const toggleLanguageDropdown = () => {
    setShowLanguageDropdown((prev) => !prev);
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    setShowLanguageDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showLanguageDropdown && !event.target.closest(".language-dropdown")) {
        setShowLanguageDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLanguageDropdown]);

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
  };

  const [points, setPoints] = useState();
  const [formData, setFormData] = useState({
    rechargeAmount: "",
  });
  const [success, setSuccess] = useState(false);

  const handleRechargePoints = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(
        `https://backend.newbrindha.com/wallet/recharge?amount=${formData.rechargeAmount}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.ok) {
        const data = await response.json();

        if (data.token) {
          localStorage.setItem("authToken", data.token);
        }
        setSuccess(true);
        setIsRechargePointsFormOpen(false);

        const balanceResponse = await fetch(
          "https://backend.newbrindha.com/wallet/balance",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (balanceResponse.ok) {
          const balanceData = await balanceResponse.json();
          window.dispatchEvent(
            new CustomEvent("updatePoints", {
              detail: balanceData.points_balance,
            }),
          );
        }

        fetchPoints();
        
        setTimeout(() => {
          navigate("/home");
        }, 2000);
      } else {
        throw new Error("Failed to Recharge");
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem("language");
    return savedLanguage || "english"; 
  });

  const handleAmountChange = (e) => {
    setFormData({ ...formData, rechargeAmount: e.target.value });
  };

  const fetchUserProfile = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `https://backend.newbrindha.com/matrimony/my_profiles`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        localStorage.removeItem("authToken");
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch profiles");
      }

      const data = await response.json();
      setUserProfile(data.profile);
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchPoints = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `https://backend.newbrindha.com/wallet/balance`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        localStorage.removeItem("authToken");
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch Points");
      }

      const data = await response.json();
      setPoints(data.points_balance);
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchSpendHistory = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `https://backend.newbrindha.com/wallet/spend/latest`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        localStorage.removeItem("authToken");
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to Fetching Spend History");
      }

      const data = await response.json();
      setSpendHistory(data.results);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchUserProfile();
    fetchPoints();
    fetchSpendHistory();
  }, []);

  // Hide success Message
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-orange-100 via-violet-200 to-indigo-300 bg-[length:400%_400%] animate-gradient font-poppins overflow-hidden relative p-0">
      <div className="min-h-[100dvh] flex-grow w-full">
        <motion.main
          className={`flex-1 transition-all duration-300 ${
            isSidebarOpen ? "lg:ml-64" : "ml-0"
          }`}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <header className="sticky top-0 z-50">
            <NavBar />
          </header>

          {/* Points Section */}
          <section className="mb-10 pt-20 overflow-y-auto px-4 sm:px-6 lg:px-8">
            <article className="flex flex-col sm:flex-row items-center justify-between py-2 gap-4 sm:gap-0">
              {userProfile && (
                <div className="flex items-center gap-3 sm:gap-4 rounded-lg w-full sm:w-auto">
                  <img
                    src={userProfile.photo_path}
                    alt={userProfile.full_name}
                    className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 object-cover bg-gray-300 rounded-full"
                  />
                  <div className="flex flex-col">
                    <p className="text-base sm:text-lg font-semibold mb-1 sm:mb-1.5">
                      {userProfile.full_name}
                    </p>
                    <button className="flex items-center justify-start gap-1.5 text-gray-800 font-semibold text-sm sm:text-base">
                      <img
                        src={NavPointsIcon}
                        alt="language-logo"
                        className="w-5 h-5 sm:w-6 sm:h-6"
                      />
                      {points}
                    </button>
                  </div>
                </div>
              )}

              {/* Points Button */}
              <div className="w-full sm:w-auto">
                <button
                  onClick={() => setIsRechargePointsFormOpen(true)}
                  className="w-full sm:w-auto text-center px-4 py-2 text-sm sm:text-base font-medium text-white bg-[#fc804f] hover:bg-[#fb6b32] active:bg-[#ff8350] rounded-lg transition-colors"
                >
                  Recharge Points
                </button>
              </div>
            </article>
          </section>

          {/* Points History */}
          <section className="px-4 sm:px-6 lg:px-8 pb-8">
            <div className="mx-auto max-w-full lg:max-w-[920px] overflow-x-auto rounded-lg">
              <p className="text-lg text-gray-800 font-medium mb-3 sm:mb-4">
                Points History
              </p>
              <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                <div className="min-w-[600px] sm:min-w-0">
                  <table className="w-full">
                    <thead className="bg-[#ff8350]">
                      <tr>
                        <th className="px-3 py-2 sm:px-4 sm:py-3 text-xs sm:text-sm font-semibold text-white uppercase tracking-wider">
                          Matrimony ID
                        </th>
                        <th className="px-3 py-2 sm:px-4 sm:py-3 text-xs sm:text-sm font-semibold text-white uppercase tracking-wider">
                          Profile Name
                        </th>
                        <th className="px-3 py-2 sm:px-4 sm:py-3 text-xs sm:text-sm font-semibold text-white uppercase tracking-wider">
                          Points Spent
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {spendHistory && spendHistory.length > 0 ? (
                        spendHistory.map((user) => (
                          <tr
                            key={user.target_profile_id}
                            className="hover:bg-gray-50"
                          >
                            <td className="px-3 py-2 sm:px-4 sm:py-3 text-xs sm:text-sm text-gray-700">
                              {user.target_profile_id}
                            </td>
                            <td className="px-3 py-2 sm:px-4 sm:py-3 text-xs sm:text-sm text-gray-700">
                              {user.target_profile_name}
                            </td>
                            <td className="px-3 py-2 sm:px-4 sm:py-3 text-xs sm:text-sm text-gray-700">
                              {user.points_spent}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={3}
                            className="px-4 py-4 text-center text-gray-400 text-sm"
                          >
                            No spent history found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>

          <AnimatePresence>
            {success && (
              <motion.div
                className="fixed inset-0 flex items-center justify-center p-4 z-50 pointer-events-none"
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={modalVariants}
              >
                <motion.div
                  className="bg-green-300 rounded-xl max-w-xs sm:max-w-sm px-4 py-3 shadow-lg"
                  variants={modalVariants}
                >
                  <h2 className="text-sm sm:text-base font-semibold text-gray-800">
                    🎉 Recharged Successfull... Check your Points ✨
                  </h2>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Recharge Points Modal */}
          <AnimatePresence>
            {isRechargePointsFormOpen && (
              <motion.div
                className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={modalVariants}
              >
                <motion.div
                  className="bg-white rounded-xl max-w-xs sm:max-w-md w-full p-4 sm:p-6 mx-2"
                  variants={modalVariants}
                >
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
                      Recharge Points
                    </h2>
                    <button
                      onClick={() => setIsRechargePointsFormOpen(false)}
                      className="p-1 rounded-lg hover:bg-gray-100 transition-colors"
                    >
                      <XMarkIcon className="h-5 w-5" />
                    </button>
                  </div>

                  <form onSubmit={handleRechargePoints} className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-2">
                        Select Amount
                      </label>
                      <select
                        name="rechargeAmount"
                        id="pointsRecharge"
                        className="w-full px-3 py-2 text-sm sm:text-base rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#FFA500] focus:border-transparent transition-all"
                        value={formData.rechargeAmount}
                        onChange={handleAmountChange}
                        required
                      >
                        <option value="">Select amount</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                      </select>
                    </div>

                    <button
                      type="submit"
                      className="w-full px-4 py-2 text-sm sm:text-base bg-[#ff8350] text-white rounded-lg hover:bg-[#fb6b32] transition-colors shadow-md"
                    >
                      Proceed to Payment
                    </button>
                  </form>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.main>
      </div>
      <Footer />
    </div>
  );
};

export default Points;